import styled from 'styled-components';
import { ButtonGroup as SonarButtonGroup } from '@appcues/sonar';

export const ButtonGroup = styled(SonarButtonGroup)`
  gap: 0;
`;
